import { MobileMaxWidth } from 'constants/Dimensions';
import Colors from 'enums/Colors';
import styled from 'styled-components';

export const CursoLivreCardContainer = styled.div<{
    backgroundColor: string;
}>`
    width: 324px;
    min-width: 324px;
    max-width: 324px;
    height: 470px;
    min-height: 470px;
    border-radius: 16px;
    background-color: ${props => props.backgroundColor};
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);
    box-sizing: border-box;

    @media only screen and (max-width: 912px) {
        width: 324px;
        min-width: 324px;
        max-width: 324px;
        margin-bottom: 20px;
        margin-top: 10px;
    }

    @media only screen and (max-width: 470px) {
        width: 324px;
    }

    @media only screen and (max-width: 350px) {
        width: 273px;
        min-width: 273px;
        max-width: 273px;
    }
`;

interface IStatusContainerProps {
    isExclusivo?: boolean;
    isNovo?: boolean;
}

export const StatusContainer = styled.div<IStatusContainerProps>`
    width: calc(100% - 24px);
    height: 40px;
    flex-shrink: 0;
    margin: 11px 12px 0;
    border-radius: 8px 8px 0 0;

    display: flex;
    align-items: center;

    background-color: ${({ isNovo }) => (isNovo ? '#00A8E9' : '#003C78')};

    box-sizing: border-box;
`;

export const StatusLabel = styled.span`
    font-family: 'Barlow';
    font-weight: 600;
    font-style: normal;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: -0.01em;
    vertical-align: middle;
    display: flex;
    align-items: center;
    color: #ffffff;
    margin-left: 16px;
`;

export const ImageContainer = styled.div<{
    hasTag: boolean;
}>`
    width: calc(100% - 24px);
    height: 183px;
    margin: ${props => (props.hasTag ? '0 12px' : '12px 12px 0')};
    flex-shrink: 0;
    display: flex;
    position: relative;
    border-radius: ${props => (props.hasTag ? '0 0 8px 8px' : '8px')};
    overflow: hidden;

    &:hover {
        cursor: pointer;
    }
`;

export const Img = styled.img<{
    hasTag: boolean;
}>`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: ${props => (props.hasTag ? '0 0 8px 8px' : '8px')};
`;

export const ContentContainer = styled.div<{
    backgroundColor: string;
}>`
    padding: 0 12px;
    width: 100%;
    background-color: ${props => props.backgroundColor};
    word-break: break-word;
    border-radius: 0 0 16px 16px;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    box-sizing: border-box;
`;

export const CardTitle = styled.p`
    width: 100%;
    color: ${Colors.Blue};
    font-family: 'Barlow';
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: -0.18px;
    margin: 16px 0 0;
    box-sizing: border-box;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    flex-shrink: 0;
`;

export const Center = styled.div<{ $alignStart?: boolean }>`
    text-align: ${props => (props.$alignStart ? 'start' : 'center')};
    width: 100%;

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        padding: 0;
        padding-bottom: 10px;
    }
`;

export const ProgressBarContainer = styled.div`
    width: 100%;
    background-color: #e5e5e5;
    border-radius: 6px;
    height: 11px;
    margin: 12px 0 20px;
    overflow: hidden;
`;

export const ProgressBarFill = styled.div<{
    percent: number;
    backgroundColor: string;
}>`
    width: ${props => props.percent}%;
    background-color: ${props => props.backgroundColor};
    height: 100%;
    border-radius: 6px;
    transition: width 0.3s ease;
`;

export const ProgressText = styled.p`
    font-family: 'Barlow';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: -0.01em;
    color: ${Colors.Blue};
    margin: 8px 0 0;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
`;

export const PrimaryYellowButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 75%;
    height: 46px;
    flex-shrink: 0;
    background-color: #ffca00;
    color: #003c78;
    font-family: 'Barlow';
    font-weight: 600;
    font-size: 14px;
    line-height: 26px;
    letter-spacing: 0.0329em;
    text-transform: uppercase;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    transition: background-color 0.2s;

    &:hover:not(:disabled) {
        background-color: #e2b500;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }
`;

export const SecondaryBlueButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 75%;
    height: 46px;
    flex-shrink: 0;
    background-color: #003c78;
    color: #ffffff;
    font-family: 'Barlow';
    font-weight: 600;
    font-size: 14px;
    line-height: 26px;
    letter-spacing: 0.0329em;
    text-transform: uppercase;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    transition: background-color 0.2s;

    &:hover:not(:disabled) {
        background-color: #002b54;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }
`;

export const BottomContainer = styled.div`
    width: 100%;
    margin-top: auto;
    padding: 16px 0;
    box-sizing: border-box;
`;

export const AboutCourseModalOverlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background-color: rgba(0, 0, 0, 0.58);
    box-sizing: border-box;
`;

export const AboutCourseModal = styled.div`
    position: relative;
    width: min(560px, 100%);
    max-width: 100%;
    max-height: calc(100vh - 40px);
    overflow-y: auto;
    padding: 40px;
    background-color: #ffffff;
    border-radius: 5px;
    box-sizing: border-box;

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        padding: 32px 24px;
    }
`;

export const AboutModalCloseButton = styled.button`
    position: absolute;
    top: 12px;
    right: 12px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: none;
    background: transparent;
    color: #000000;
    font-family: Arial, sans-serif;
    font-size: 28px;
    line-height: 1;
    cursor: pointer;
`;

export const AboutCourseTitle = styled.h2`
    margin: 0 24px 16px 0;
    color: #003c78;
    font-family: 'Barlow';
    font-size: 22px;
    font-weight: 600;
    line-height: 1.3;
`;

export const AboutCourseDescription = styled.p`
    margin: 0 0 24px;
    color: #003c78;
    font-family: 'Barlow';
    font-size: 16px;
    line-height: 1.5;
`;

export const AboutCourseInfo = styled.p`
    margin: 0 0 12px;
    color: #000000;
    font-family: 'Barlow';
    font-size: 14px;
    line-height: 1.5;

    &:last-child {
        margin-bottom: 0;
    }
`;
